import { NavigateBackLink } from '@exam-center/components';
import { PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useExamLocationDetails } from '../../providers/exam-location-details-provider';

export default function ExamLocationDetailsPageHeader() {
  const { roomDetails, examCenterCode } = useExamLocationDetails();

  return (
    <PageHeader
      title={roomDetails.name}
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-location/locations'
          params={{ examCenterCode }}
          label='Back'
        />
      }
      subtitleSection={
        <Text color='text.secondary' variant='body2'>
          วันที่อนุมัติสิทธิ์ใช้งาน:{' '}
          {roomDetails.createdAt ? formatDateTime(roomDetails.createdAt) : '-'}
        </Text>
      }
    />
  );
}
